import { intersection, isEmpty, map } from 'lodash'

import { ROLES } from '../../common/constants'

const checkIfQaAssignableUser = user =>
  !isEmpty(
    intersection(map(user?.roles, 'name'), [
      ROLES.QA.value,
      ROLES.QA_TRAINEE.value,
      ROLES.QC.value,
      ROLES.QC_TRAINEE.value,
      ROLES.ADMIN.value,
      ROLES.GUILD_LEAD.value,
      ROLES.TRAINER.value,
      ROLES.ML_DETECTIVE.value,
    ]),
  )

export default checkIfQaAssignableUser
